(function () {
  'use strict';

  /* ---- Helpers -------------------------------------------- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
  }

  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ---- Focus trap ----------------------------------------- */
  function createFocusTrap(el) {
    var sel = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';
    function getEls() {
      return Array.from(el.querySelectorAll(sel)).filter(function (e) {
        return !e.closest('[inert]') && !e.closest('[hidden]');
      });
    }
    function handler(e) {
      if (e.key !== 'Tab') return;
      var els = getEls();
      if (!els.length) return;
      var first = els[0], last = els[els.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
    el.addEventListener('keydown', handler);
    return function () { el.removeEventListener('keydown', handler); };
  }

  /* ---- Body scroll lock ----------------------------------- */
  function lockScroll()   { document.body.style.overflow = 'hidden'; }
  function unlockScroll() { document.body.style.overflow = ''; }

  /* ---- Smart-hide + transparent header ------------------- */
  (function initStickyHeader() {
    var header = qs('.js-header');
    if (!header) return;
    var behavior    = header.dataset.sticky;
    var transparent = header.dataset.transparent === 'true';

    if (behavior === 'off' && !transparent) { header.style.position = 'relative'; return; }
    if (behavior !== 'smart_hide' && !transparent) return;

    var lastY = 0, ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY;

        if (transparent) {
          header.classList.toggle('cb-header--solid', y > 60);
        } else {
          header.classList.toggle('cb-header--scrolled', y > 10);
        }

        if (behavior === 'smart_hide') {
          if (y > lastY && y > 80) {
            header.classList.add('cb-header--hidden');
          } else {
            header.classList.remove('cb-header--hidden');
          }
        }

        lastY = y;
        ticking = false;
      });
    }, { passive: true });
  })();

  /* ---- ESC global handler --------------------------------- */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeNavDrawer();
    closeSearch();
    closeCartDrawer();
    closeDropdowns();
  });

  /* ---- Desktop Dropdowns ---------------------------------- */
  function closeDropdowns() {
    qsa('.js-has-dropdown').forEach(function (item) {
      item.classList.remove('is-open');
      var btn = item.querySelector('.js-nav-link');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.js-has-dropdown')) closeDropdowns();
  });

  /* ---- Nav Drawer ----------------------------------------- */
  var navDrawer  = qs('.js-nav-drawer');
  var navOverlay = qs('.js-nav-overlay');
  var burgerBtn  = qs('.js-header-burger');
  var navClose   = qs('.js-nav-drawer-close');
  var navTrapRelease;
  var prevFocusNav;

  if (navDrawer) navDrawer.setAttribute('inert', '');

  function openNavDrawer() {
    if (!navDrawer) return;
    prevFocusNav = document.activeElement;
    navDrawer.removeAttribute('hidden');
    navDrawer.removeAttribute('inert');
    if (navOverlay) navOverlay.classList.add('is-visible');
    if (burgerBtn) burgerBtn.setAttribute('aria-expanded', 'true');
    lockScroll();
    navTrapRelease = createFocusTrap(navDrawer);
    var first = navDrawer.querySelector('button, a');
    if (first) first.focus();
  }

  function closeNavDrawer() {
    if (!navDrawer || navDrawer.hasAttribute('hidden')) return;
    navDrawer.setAttribute('hidden', '');
    navDrawer.setAttribute('inert', '');
    if (navOverlay) navOverlay.classList.remove('is-visible');
    if (burgerBtn) burgerBtn.setAttribute('aria-expanded', 'false');
    unlockScroll();
    if (navTrapRelease) { navTrapRelease(); navTrapRelease = null; }
    resetNavLevels();
    if (prevFocusNav) { prevFocusNav.focus(); prevFocusNav = null; }
  }

  function resetNavLevels() {
    qsa('.js-nav-subnav').forEach(function (s) {
      s.setAttribute('hidden', '');
      s.setAttribute('inert', '');
    });
    var level0 = qs('.js-nav-level[data-level="0"]');
    if (level0) { level0.removeAttribute('hidden'); level0.removeAttribute('inert'); }
    qsa('.js-nav-has-children').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }

  if (burgerBtn) burgerBtn.addEventListener('click', openNavDrawer);
  if (navClose)  navClose.addEventListener('click', closeNavDrawer);
  if (navOverlay) navOverlay.addEventListener('click', closeNavDrawer);

  // Sub-nav push navigation
  qsa('.js-nav-has-children').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var targetId = btn.dataset.target;
      var target = targetId ? document.getElementById(targetId) : null;
      if (!target) return;
      var level0 = qs('.js-nav-level[data-level="0"]');
      if (level0) { level0.setAttribute('hidden', ''); level0.setAttribute('inert', ''); }
      target.removeAttribute('hidden');
      target.removeAttribute('inert');
      btn.setAttribute('aria-expanded', 'true');
      var back = target.querySelector('.js-nav-back');
      if (back) back.focus();
    });
  });

  qsa('.js-nav-back').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var subnav = btn.closest('.js-nav-subnav');
      if (subnav) { subnav.setAttribute('hidden', ''); subnav.setAttribute('inert', ''); }
      var level0 = qs('.js-nav-level[data-level="0"]');
      if (level0) { level0.removeAttribute('hidden'); level0.removeAttribute('inert'); }
      if (subnav) {
        var trigger = qs('[data-target="' + subnav.id + '"]');
        if (trigger) { trigger.setAttribute('aria-expanded', 'false'); trigger.focus(); }
      }
    });
  });

  // Init sub-nav inert
  qsa('.js-nav-subnav').forEach(function (s) { s.setAttribute('inert', ''); });

  /* ---- Search Overlay ------------------------------------- */
  var searchOverlay = qs('.js-search-overlay');
  var searchToggle  = qs('.js-search-toggle');
  var searchClose   = qs('.js-search-close');
  var searchInput   = qs('.js-search-input');
  var searchResults = qs('.js-search-results');
  var searchFeatured = qs('.js-search-featured');
  var searchTrapRelease;
  var prevFocusSearch;
  var searchDebounce;

  if (searchOverlay) searchOverlay.setAttribute('inert', '');

  function openSearch() {
    if (!searchOverlay) return;
    prevFocusSearch = document.activeElement;
    searchOverlay.removeAttribute('hidden');
    searchOverlay.removeAttribute('inert');
    if (searchToggle) searchToggle.setAttribute('aria-expanded', 'true');
    lockScroll();
    searchTrapRelease = createFocusTrap(searchOverlay);
    if (searchInput) { searchInput.value = ''; searchInput.focus(); }
    if (searchFeatured) searchFeatured.removeAttribute('hidden');
    var dyn = searchResults && searchResults.querySelector('.cb-search-dynamic');
    if (dyn) dyn.remove();
  }

  function closeSearch() {
    if (!searchOverlay || searchOverlay.hasAttribute('hidden')) return;
    searchOverlay.setAttribute('hidden', '');
    searchOverlay.setAttribute('inert', '');
    if (searchToggle) searchToggle.setAttribute('aria-expanded', 'false');
    unlockScroll();
    if (searchTrapRelease) { searchTrapRelease(); searchTrapRelease = null; }
    if (prevFocusSearch) { prevFocusSearch.focus(); prevFocusSearch = null; }
  }

  if (searchToggle) searchToggle.addEventListener('click', openSearch);
  if (searchClose)  searchClose.addEventListener('click', closeSearch);

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      clearTimeout(searchDebounce);
      var q = searchInput.value.trim();
      if (q.length < 3) {
        if (searchFeatured) searchFeatured.removeAttribute('hidden');
        var dyn = searchResults && searchResults.querySelector('.cb-search-dynamic');
        if (dyn) dyn.remove();
        return;
      }
      if (searchFeatured) searchFeatured.setAttribute('hidden', '');
      searchDebounce = setTimeout(function () { fetchSearch(q); }, 300);
    });
  }

  function fetchSearch(q) {
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection&resources[limit]=4' +
      '&resources[fields]=title,image,price,url,variants.price';
    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var res = data && data.resources && data.resources.results;
        renderSearchResults(res, q);
      })
      .catch(function () {});
  }

  function renderSearchResults(results, q) {
    if (!searchResults) return;
    var old = searchResults.querySelector('.cb-search-dynamic');
    if (old) old.remove();

    var products    = (results && results.products)    || [];
    var collections = (results && results.collections) || [];

    var wrap = document.createElement('div');
    wrap.className = 'cb-search-dynamic';

    if (!products.length && !collections.length) {
      wrap.innerHTML = '<p class="cb-search-no-result">Aucun résultat pour « ' + escHtml(q) + ' »</p>';
      searchResults.appendChild(wrap);
      return;
    }

    var html = '<div class="cb-search-results-grid">';
    if (products.length) {
      html += '<div class="cb-search-products">';
      products.forEach(function (p) {
        var imgSrc = p.image || (p.featured_image && p.featured_image.url) || '';
        var img = imgSrc
          ? '<img src="' + escHtml(imgSrc) + '" alt="' + escHtml(p.title) + '" loading="lazy">'
          : '<div style="background:var(--cb-cream-alt);aspect-ratio:1"></div>';
        var price = p.price ? formatMoney(parseInt(p.price, 10)) : '';
        html += '<a href="' + escHtml(p.url) + '" class="cb-search-product-card">' +
          img +
          '<p class="cb-search-product-title">' + escHtml(p.title) + '</p>' +
          (price ? '<p class="cb-search-product-price">' + price + '</p>' : '') +
          '</a>';
      });
      html += '</div>';
    }
    if (collections.length) {
      html += '<div class="cb-search-collections">';
      collections.forEach(function (c) {
        html += '<a href="' + escHtml(c.url) + '" class="cb-search-collection-link">' + escHtml(c.title) + '</a>';
      });
      html += '</div>';
    }
    html += '</div>';

    wrap.innerHTML = html;
    searchResults.appendChild(wrap);
  }

  /* ---- Cart Drawer ---------------------------------------- */
  var cartDrawer   = qs('.js-cart-drawer');
  var cartOverlay  = qs('.js-cart-overlay');
  var cartToggle   = qs('.js-cart-toggle');
  var cartClose    = qs('.js-cart-close');
  var cartItems    = qs('.js-cart-items');
  var cartEmpty    = qs('.js-cart-empty');
  var cartFooter   = qs('.js-cart-footer');
  var cartSubtotal = qs('.js-cart-subtotal');
  var cartCountEl  = qs('.js-cart-count');
  var cartBadge    = qs('.js-cart-badge');
  var cartTrapRelease;
  var prevFocusCart;

  if (cartDrawer) cartDrawer.setAttribute('inert', '');

  function openCartDrawer() {
    if (!cartDrawer) return;
    prevFocusCart = document.activeElement;
    cartDrawer.removeAttribute('hidden');
    cartDrawer.removeAttribute('inert');
    if (cartOverlay) cartOverlay.classList.add('is-visible');
    if (cartToggle) cartToggle.setAttribute('aria-expanded', 'true');
    lockScroll();
    cartTrapRelease = createFocusTrap(cartDrawer);
    var first = cartDrawer.querySelector('button');
    if (first) first.focus();
    fetchCart();
  }

  function closeCartDrawer() {
    if (!cartDrawer || cartDrawer.hasAttribute('hidden')) return;
    cartDrawer.setAttribute('hidden', '');
    cartDrawer.setAttribute('inert', '');
    if (cartOverlay) cartOverlay.classList.remove('is-visible');
    if (cartToggle) cartToggle.setAttribute('aria-expanded', 'false');
    unlockScroll();
    if (cartTrapRelease) { cartTrapRelease(); cartTrapRelease = null; }
    if (prevFocusCart) { prevFocusCart.focus(); prevFocusCart = null; }
  }

  if (cartToggle)  cartToggle.addEventListener('click', openCartDrawer);
  if (cartClose)   cartClose.addEventListener('click', closeCartDrawer);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);

  function fetchCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  function renderCart(cart) {
    updateBadge(cart.item_count);
    if (cartCountEl) {
      cartCountEl.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';
    }
    if (!cartItems) return;

    // Clear dynamic items (keep .js-cart-empty)
    Array.from(cartItems.children).forEach(function (c) {
      if (!c.classList.contains('js-cart-empty')) c.remove();
    });

    if (cart.item_count === 0) {
      if (cartEmpty)  cartEmpty.removeAttribute('hidden');
      if (cartFooter) cartFooter.setAttribute('hidden', '');
      return;
    }

    if (cartEmpty)    cartEmpty.setAttribute('hidden', '');
    if (cartFooter)   cartFooter.removeAttribute('hidden');
    if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.total_price);

    cart.items.forEach(function (item) {
      var img = item.image
        ? '<img class="cb-cart-item-img" src="' + escHtml(item.image) + '" alt="' + escHtml(item.title) + '" loading="lazy">'
        : '<div class="cb-cart-item-img" style="background:var(--cb-cream-alt)"></div>';
      var variant = item.variant_title && item.variant_title !== 'Default Title'
        ? '<p class="cb-cart-item-variant">' + escHtml(item.variant_title) + '</p>'
        : '';
      var el = document.createElement('div');
      el.className = 'cb-cart-item';
      el.dataset.key = item.key;
      el.innerHTML = img +
        '<div class="cb-cart-item-info">' +
          '<p class="cb-cart-item-title"><a href="' + escHtml(item.url) + '" style="color:inherit;text-decoration:none">' + escHtml(item.title) + '</a></p>' +
          variant +
          '<p class="cb-cart-item-price">' + formatMoney(item.line_price) + '</p>' +
          '<div class="cb-cart-item-actions">' +
            '<div class="cb-cart-qty-wrap">' +
              '<button class="cb-cart-qty-btn" aria-label="Diminuer la quantité" data-action="change" data-key="' + escHtml(item.key) + '" data-qty="' + (item.quantity - 1) + '">−</button>' +
              '<span class="cb-cart-qty">' + item.quantity + '</span>' +
              '<button class="cb-cart-qty-btn" aria-label="Augmenter la quantité" data-action="change" data-key="' + escHtml(item.key) + '" data-qty="' + (item.quantity + 1) + '">+</button>' +
            '</div>' +
            '<button class="cb-cart-remove" aria-label="Supprimer ' + escHtml(item.title) + '" data-action="change" data-key="' + escHtml(item.key) + '" data-qty="0">Supprimer</button>' +
          '</div>' +
        '</div>';
      cartItems.appendChild(el);
    });
  }

  // Delegated events for qty / remove
  if (cartItems) {
    cartItems.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-action="change"]');
      if (!btn) return;
      var key = btn.dataset.key;
      var qty = parseInt(btn.dataset.qty, 10);
      if (!key || isNaN(qty)) return;
      cartChange(key, qty);
    });
  }

  function cartChange(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  /* ---- Badge update --------------------------------------- */
  function updateBadge(count) {
    if (!cartBadge) return;
    cartBadge.textContent = count;
    if (count > 0) cartBadge.removeAttribute('hidden');
    else cartBadge.setAttribute('hidden', '');
    if (cartToggle) {
      cartToggle.setAttribute('aria-label', 'Panier (' + count + ' article' + (count !== 1 ? 's' : '') + ')');
    }
  }

  /* ---- Intercept ATC → open cart drawer ------------------ */
  var _origFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input instanceof Request ? input.url : '');
    var result = _origFetch.apply(this, arguments);
    if (url && url.indexOf('/cart/add') !== -1) {
      result.then(function (resp) {
        if (resp.ok) openCartDrawer();
      }).catch(function () {});
    }
    return result;
  };

  /* ---- Announcement bar ----------------------------------- */
  (function initAnnouncement() {
    var bar = qs('.js-announcement');
    if (!bar) return;

    // Dismiss
    if (bar.dataset.dismissible === 'true') {
      if (sessionStorage.getItem('cb-ann-dismissed')) {
        bar.style.display = 'none';
        return;
      }
      var closeBtn = qs('.js-announcement-close');
      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          bar.style.display = 'none';
          sessionStorage.setItem('cb-ann-dismissed', '1');
        });
      }
    }

    var msgs = qsa('.js-announcement-msg');
    if (msgs.length < 2) return;

    var current = 0;
    var transitioning = false;
    var timer;
    var DURATION = 650;

    function showMsg(nextIdx, dir) {
      if (transitioning || nextIdx === current) return;
      transitioning = true;

      var leavingEl = msgs[current];
      var enteringEl = msgs[nextIdx];
      var leavingClass = dir === 'prev' ? 'is-leaving-down' : 'is-leaving';

      // Position entering message at correct start for direction
      if (dir === 'prev') {
        enteringEl.classList.add('is-from-top');
        void enteringEl.offsetHeight;
      }

      // Exit current
      leavingEl.classList.remove('is-active');
      leavingEl.classList.add(leavingClass);
      leavingEl.setAttribute('aria-hidden', 'true');

      // Enter next on next frame so CSS transition fires
      requestAnimationFrame(function () {
        enteringEl.classList.remove('is-from-top');
        enteringEl.classList.add('is-active');
        enteringEl.setAttribute('aria-hidden', 'false');
        current = nextIdx;

        // Clean up leaving element without visible snap-back
        setTimeout(function () {
          leavingEl.style.transition = 'none';
          leavingEl.classList.remove(leavingClass);
          void leavingEl.offsetHeight;
          leavingEl.style.transition = '';
          transitioning = false;
        }, DURATION);
      });
    }

    function goNext() { showMsg((current + 1) % msgs.length, 'next'); }
    function goPrev() { showMsg((current - 1 + msgs.length) % msgs.length, 'prev'); }

    function startTimer() {
      clearInterval(timer);
      timer = setInterval(goNext, 4000);
    }

    startTimer();

    var prevBtn = qs('.js-ann-prev');
    var nextBtn = qs('.js-ann-next');

    if (prevBtn) prevBtn.addEventListener('click', function () { goPrev(); startTimer(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goNext(); startTimer(); });
  })();

})();
